import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'

/**
 * When building a new metric comparison report, the model is use is the actual
 * Report model, however first two steps of the report expect to work solely with
 * a Backbone Model of the filter.  This adapter allows building the new report
 * to work with the code that updates just the filter itself.
 */
const NewMetricComparisonReportAdapter = Backbone.View.extend({

	initialize: function(options) {
		this.reportModel = options.model
		this.model = new Backbone.Model(this.reportModel.attributes.filters.compareScorecardItems[0])

		this.model.on('change', () => {
			this.reportModel.attributes.filters.compareScorecardItems[0] = this.model.attributes
			this.reportModel.trigger('change')
		})
		this.filterView = new options.filterView(_.defaults({model: this.model}, options))
		this.setElement(this.filterView.el)
		this.className = this.filterView.className
	},

	setupTwoColumnDetailsForm: function() {
		_.invoke(this.filterView, 'setupTwoColumnDetailsForm')
	},

	render: function() {
		return this.filterView.render()
	},

	remove: function() {
		this.filterView.remove()
	}

})

export default NewMetricComparisonReportAdapter
NewMetricComparisonReportAdapter.__filename__ = 'reports/wizard/metric-comparison/new-metric-comparsion-view-adapter.js'
